export default __webpack_public_path__ + "agent_bg575997b.png";